// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3ERQb","upload":"Small_upload__3ZwS5","imageWrap":"Small_imageWrap__24wiX","removeBtn":"Small_removeBtn__2kH9J"};